// SalesEditActions.js
import React from "react";
import {
  UncontrolledButtonDropdown,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Trans } from "react-i18next";
import { SubmitButton } from "components/common";

export const SalesEditActions = ({ item, onSave }) => {
  const [loading, setLoading] = React.useState(false);
  const preOnSave = (data) => {
    setLoading(true);
    onSave(data)
    setTimeout(() => setLoading(false), 3000);
  }
  return (
    <div className="d-flex">
      {item.Status === "DRAFT" && (
        <UncontrolledButtonDropdown>
          <Button color="primary" disabled={loading} onClick={() => preOnSave({ draft: true })}>
            <Trans>Save</Trans>
          </Button>
          <DropdownToggle caret color="primary" />
          <DropdownMenu>
            <DropdownItem disabled={loading} onClick={() => preOnSave({ draft: true })}>
              <Trans>Save as draft</Trans>
            </DropdownItem>
            <DropdownItem disabled={loading} onClick={() => preOnSave({ draft: true })}>
              <Trans>Save (continue editing)</Trans>
            </DropdownItem>
            <DropdownItem disabled={loading} onClick={() => preOnSave({ submit: true })}>
              <Trans>Save & submit for approval</Trans>
            </DropdownItem>
            <DropdownItem
              disabled={loading} onClick={() => preOnSave({ draft: true, addAnother: true })}
            >
              <Trans>Save & add another</Trans>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      )}
      <div className="mx-auto" />
      {(item.Status === "DRAFT" || item.Status === "SUBMITTED") && (
        <UncontrolledButtonDropdown>
          <Button color="primary" disabled={loading} onClick={() => preOnSave({ approve: true })}>
            <Trans>Approve</Trans>
          </Button>
          <DropdownToggle caret color="primary" />
          <DropdownMenu>
            <DropdownItem disabled={loading} onClick={() => preOnSave({ approve: true })}>
              <Trans>Approve</Trans>
            </DropdownItem>
            <DropdownItem
              disabled={loading} onClick={() => preOnSave({ approve: true, addAnother: true })}
            >
              <Trans>Approve & add another</Trans>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      )}
      {(item.Status === "AUTHORISED" || item.Status === "SUBMITTED") && (
        <SubmitButton disabled={loading} color="success" onClick={preOnSave}>
          Update
        </SubmitButton>
      )}
    </div>
  )
};

export default SalesEditActions;
